import { createPortal } from 'react-dom';
import { Box } from '@bpba/ui-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Keyboard } from 'swiper';

type Props = {
    imagenes: string[];
    slideInicial: number;
    onClose: () => void;
};

export function FullScreenGallery({
    imagenes,
    slideInicial,
    onClose,
}: Props) {
    return createPortal(
        <>
            {/* BOTÓN CERRAR — viewport real */}
            <Box
                position="fixed"
                top="16px"
                left="calc(100vw - 48px)"
                color="white"
                fontSize="32px"
                style={{ cursor: "pointer", userSelect: "none" }}
                zIndex={2147483647}
                onClick={onClose}
                aria-label="Cerrar galería"
            >
                ✕
            </Box>

            {/* OVERLAY */}
            <Box
                position="fixed"
                style={{ inset: 0 }}
                backgroundColor="rgba(0,0,0,0.95)"
                zIndex={2147483000}
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                {/* CONTENEDOR DEL SWIPER */}
                <Box width="90%" height="90%">

                    <Swiper
                        modules={[Keyboard]}
                        initialSlide={slideInicial}
                        slidesPerView={1}
                        spaceBetween={16}
                        keyboard={{
                            enabled: true,
                            onlyInViewport: false, // 👈 clave para fullscreen
                        }}
                        style={{ width: '100%', height: '100%' }}
                    >
                        {imagenes.map((img, index) => (
                            <SwiperSlide key={index}>
                                <Box
                                    width="100%"
                                    height="100%"
                                    backgroundImage={`url(${img})`}
                                    backgroundRepeat="no-repeat"
                                    backgroundPosition="center"
                                    backgroundSize="contain"
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>

                </Box>
            </Box>
        </>,
        document.body
    );
}